import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserServices } from "../../../services/user/user.services";
import { handleCopy, handleExcel, handlePDF, handlePrint } from "../../../utils/filedownload";

const MyTeamComponent = () => {
    const navigate = useNavigate();
    const selectedStore = useSelector(state => state?.user?.selectedStoreId);
    const [filterText, setFilterText] = useState("");
    const [usersData, setUsersData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const rowsPerPage = 5;

    useEffect(() => {
        const fetchUsersData = async () => {
            try {
                const response = await UserServices.getAllUsers(selectedStore);
                if (response) {
                    setUsersData(response);
                }
            }
            catch (error) {
                console.error("Error fetching users");
                setUsersData([])
            }
        }
        fetchUsersData();
    }, []);

    // Columns for DataTable
    const columns = [
        { name: "UserName", selector: row => row.username, sortable: true },
        { name: "Full Name", selector: row => `${row.firstName} ${row.lastName}`, sortable: true, wrap: true },
        { name: "Email", selector: row => row.email, sortable: true },
        { name: "Phone", selector: row => row.phone, sortable: true },
        { name: "Role", selector: row => row.role?.roleName, sortable: true },
        { name: "Max Discount(%)", selector: row => row.maxDiscount, sortable: true },
        {
            name: "Active?",
            selector: row => row.isActive,
            sortable: true,
            cell: row => (
                <button
                    className={`btn btn-light radius-30 px-4 ${row.isActive ? 'text-success' : 'text-danger'}`}
                >
                    {row.isActive ? "Active" : "Inactive"}
                </button>
            ),
            center: true,
        },
    ];

    // Filter data based on search text
    const filteredData = usersData.filter(item =>
    (item.username?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.role?.roleName?.toLowerCase().includes(filterText.toLowerCase()))
    );

    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const handleBackClick = () => {
        navigate("/dashboard");
    };

    return (
        <div className="page-wrapper m-0">
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3 text-primary fw-bold fs-4">My Team</div>
                    <div className="ms-auto">
                        <button
                            className="btn btn-outline-secondary me-2 px-4 py-2 rounded-3 shadow-sm"
                            onClick={handleBackClick}
                        >
                            Back
                        </button>
                    </div>
                </div>

                <div className="card radius-10 border-top border-0 border-4 border-primary">
                    <div className="card-body">
                        <div className="d-flex flex-column flex-md-row mb-3">
                            <div className="btn-group me-2 mb-md-0 mb-sm-0">
                                <button className="btn btn-outline-primary" onClick={() => handleCopy(filteredData)}>Copy</button>
                                <button className="btn btn-outline-success" onClick={() => handleExcel(filteredData)}>Excel</button>
                                <button className="btn btn-outline-danger" onClick={() => handlePDF(filteredData)}>PDF</button>
                                <button className="btn btn-outline-info" onClick={handlePrint}>Print</button>
                            </div>

                            <div className="d-flex ms-auto align-items-center">
                                <div className="me-2"><span className="fw-bold">Search:</span></div>
                                <input
                                    type="text"
                                    className="form-control rounded-3"
                                    placeholder="Search 🔍..."
                                    value={filterText}
                                    onChange={e => setFilterText(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="table-responsive">
                            <DataTable
                                columns={columns}
                                data={currentData}
                                fixedHeader
                                responsive
                                highlightOnHover
                                sortIcon={<i className="bx bx-sort" />}
                            />
                        </div>

                        {/* Pagination Controls */}
                        <div className="d-flex mt-4 justify-content-end">
                            <div className="btn-group">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    Prev
                                </button>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <button
                                        key={index}
                                        className={`btn ${currentPage === index + 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
                                        onClick={() => handlePageChange(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyTeamComponent;
